export default {
  title: 'Maksut',
  subtitle: 'Ravintolakohtainen palvelumaksun ohitus kohteelle {{company}}.',
  card_title: 'Palvelumaksu',
  banner: {
    default_summary: 'Kumppanin oletus: {{percentage}} % · min {{min}} · max {{max}}.',
    override_hint: 'Ohita alla asettaaksesi tälle ravintolalle eri maksun.',
    suggested_summary: 'Ehdotetut alkuarvot: {{percentage}} % · min {{min}} · max {{max}}.',
    suggested_hint: 'Muokkaa niitä alla ja tallenna ottaaksesi palvelumaksun käyttöön tässä ravintolassa.',
    own_fee_hint: 'Tämä ravintola veloittaa omaa maksuaan, asetettu alla.',
    saved_summary: 'Viimeksi tallennetut arvosi: {{percentage}} % · min {{min}} · max {{max}}.',
    saved_hint:
      'Palvelumaksu on pois käytöstä. Tallenna nämä, tai muuta niitä ensin, ottaaksesi sen takaisin käyttöön.',
  },
  form: {
    recommended: 'Suositus: {{value}}',
    percentage: {
      label: 'Palvelumaksuprosentti',
      tooltip: 'Prosenttiosuus tilauksen arvosta, joka veloitetaan ruokailijalta palvelumaksuna.',
    },
    min_amount: {
      label: 'Vähimmäispalvelumaksun määrä',
      tooltip: 'Tätä määrää pienemmät lasketut maksut pyöristetään ylöspäin tähän.',
    },
    max_amount: {
      label: 'Enimmäispalvelumaksun määrä',
      tooltip: 'Palvelumaksu ei koskaan ylitä tätä määrää, tilauksen arvosta riippumatta.',
    },
  },
  limits: 'Pysyttävä FoodAmigosin rajoissa: enintään {{max_percentage}} % / {{max_amount}}, vähintään {{min_amount}}.',
  not_charged_notice:
    'Tässä ravintolassa ei veloiteta palvelumaksua juuri nyt. Tallenna alla oleva maksu ottaaksesi sen käyttöön.',
  zero_percentage_warning:
    '0 %:n prosenttiosuus ei poista palvelumaksua käytöstä: vähimmäismäärää pienemmät lasketut maksut pyöristetään ylöspäin siihen, joten jokaiselta tilaukselta veloitetaan silti vähintään vähimmäismäärä.',
  buttons: {
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    save: 'Tallenna',
    reset_to_default: 'Palauta kumppanin oletusarvoon',
    turn_off: 'Poista palvelumaksu käytöstä',
  },
  toasts: {
    load_error: 'Palvelumaksuasetuksia ei voitu ladata.',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
    reset_to_default: 'Ohitus poistettu — kumppanin oletusarvo on voimassa.',
    reset_to_default_skipped: 'Ohitus poistettu — palvelumaksua ei veloiteta ennen kuin tallennat sellaisen.',
    turned_off: 'Palvelumaksu poistettu käytöstä. Arvosi säilyvät, kun otat sen uudelleen käyttöön.',
  },
};
